import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Button, ButtonGroup, Grid } from '@mui/material';
import { TransformDate } from '../DatePickerUtils/datePickerUtils';

const RoundedButton = styled(Button)(() => ({
  minWidth: '35px',
  padding: '5px 2px',
  borderRadius: '50%',
  borderColor: '#D9D9D9',
  borderWidth: 2,
  borderStyle: 'solid',
  color: '#000',
  marginRight: '4px',
  fontSize: '12px',
  fontWeight: 'bold',
  '&:hover': {
    background: '#FFEC3F',
  },
  '&:active': {
    background: '#FFEC3F',
  },
}));

const StyledButton = (props) => {
  const { month, weeks, selectedWeeks, onWeekClick, quarter, year, isCurrYearSame, currentWeek } =
    props;
  const updatedSelectedWeeks = selectedWeeks && TransformDate.addWeek53ToLeapYearQ4(selectedWeeks);
  const selectedWeeksData =
    updatedSelectedWeeks &&
    updatedSelectedWeeks?.find((data) => data?.currYear === year && data?.[quarter]);
  const selectedWeeksForQuarter = selectedWeeksData ? selectedWeeksData?.[quarter] : [];

  return (
    <Grid key={month} item xs={6}>
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>{month}</div>
      <ButtonGroup>
        {weeks &&
          weeks.map((week) => (
            <RoundedButton
              key={week}
              variant={selectedWeeksForQuarter.includes(week) ? 'contained' : 'outlined'}
              onClick={() => onWeekClick(month, week, quarter, year)}
              disabled={
                isCurrYearSame ? TransformDate?.valueGreaterThanCurrWeek(week, currentWeek) : false
              } // disabling the week buttons for future weeks
            >
              {week}
            </RoundedButton>
          ))}
      </ButtonGroup>
    </Grid>
  );
};

// Prop validation
StyledButton.propTypes = {
  month: PropTypes.string,
  weeks: PropTypes.arrayOf(PropTypes.string),
  selectedWeeks: PropTypes.arrayOf(PropTypes.string),
  onWeekClick: PropTypes.func,
  quarter: PropTypes.string,
  year: PropTypes.number,
  isCurrYearSame: PropTypes.bool,
  currentWeek: PropTypes.string,
};

export default StyledButton;
